export const FETCH_FAILED = "Couldn't connect to the server. Please check your Internet connection or try again later.";
export const IMAGE_TOO_LARGE = "Image size too large (max 20 MB)";
export const INTERNAL_ERROR = "Internal error";
export const SERVER_ERROR = "Server error";
